export const NAV_CHANGE = 'header/nav_change';
export const MAGNIFY_START = 'header/magnify_start';
export const MAGNIFY_STOP = 'header/magnify_stop';